export const state = {
    navSystem:{urlTo:""}
}

export const mutations = {
    setNav(state, NavUrl) {
        state.navSystem = {"urlTo":NavUrl} 
    } 
}